import { render, staticRenderFns } from "./PanelItem.vue?vue&type=template&id=4a04dbb7&scoped=true"
import script from "./PanelItem.vue?vue&type=script&lang=js"
export * from "./PanelItem.vue?vue&type=script&lang=js"
import style0 from "./PanelItem.vue?vue&type=style&index=0&id=4a04dbb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04dbb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a04dbb7')) {
      api.createRecord('4a04dbb7', component.options)
    } else {
      api.reload('4a04dbb7', component.options)
    }
    module.hot.accept("./PanelItem.vue?vue&type=template&id=4a04dbb7&scoped=true", function () {
      api.rerender('4a04dbb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelItem.vue"
export default component.exports